import { Entity } from 'engine/Entity';
import { ColliderFacet, ColliderType } from 'engine/facets/ColliderFacet';
import { StaticSpriteFacet } from 'engine/facets/StaticSpriteFacet';
import { create } from 'engine/lib/create';
import { DeskSprite } from './EndSprites';

export class Desk extends Entity {
  createFacets() {
    return [
      create(StaticSpriteFacet, { frame: DeskSprite, offset: [-150, -164] }),
      create(ColliderFacet, { type: ColliderType.Box, size: [300, 120], offset: [-150, -57] }),
    ];
  }
}
